var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8337 100.625C95.8337 93.9379 95.8337 90.5944 95.0083 87.8737C93.1501 81.748 88.3565 76.9543 82.2308 75.0961C79.5101 74.2708 76.1666 74.2708 69.4795 74.2708H45.5212C38.8341 74.2708 35.4905 74.2708 32.7699 75.0961C26.6442 76.9543 21.8505 81.748 19.9923 87.8737C19.167 90.5944 19.167 93.9379 19.167 100.625M79.0628 35.9375C79.0628 47.8461 69.409 57.5 57.5003 57.5C45.5917 57.5 35.9378 47.8461 35.9378 35.9375C35.9378 24.0289 45.5917 14.375 57.5003 14.375C69.409 14.375 79.0628 24.0289 79.0628 35.9375Z",
    stroke: "#6E56CF",
    strokeWidth: 9.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f597fd3dc5059e0a721b34fae0d38abe.svg";
export { ForwardRef as ReactComponent };